var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 25.854,
    viewBox: "0 0 20 25.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(0 25.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M5.912-11.256a.427.427,0,0,1-.361-.139.57.57,0,0,1-.194-.471c.083-.555,1-1.194,1.637-1.444.139-.055.278-.11.444-.194A20.957,20.957,0,0,0,8.465-16a3.5,3.5,0,0,1-.278-2.137.687.687,0,0,1,.528-.472.556.556,0,0,1,.527.195c.084.111.36.444-.056,1.776,0,0-.083.25-.222.638a4.949,4.949,0,0,0,1,1.471l.278.278a5.662,5.662,0,0,1,.943-.083,1.92,1.92,0,0,1,1.36.333.513.513,0,0,1,.139.444.627.627,0,0,1-.416.5,2.438,2.438,0,0,1-2.165-.722,13.2,13.2,0,0,0-2.359.666,4.848,4.848,0,0,1-.86,1.277A1.279,1.279,0,0,1,5.912-11.256Zm1.193-1.582c-.666.305-1.249.833-1.277,1.055l.028.028c.083.083.416-.028.749-.388A3.735,3.735,0,0,0,7.105-12.838ZM10.8-13.865a1.64,1.64,0,0,0,1.332.361c.083-.028.111-.083.139-.083,0-.056,0-.083-.028-.083-.056-.083-.278-.195-1.027-.195ZM8.771-15.391c-.195.5-.444,1.111-.694,1.693a13.934,13.934,0,0,1,1.637-.444L9.659-14.2A5.141,5.141,0,0,1,8.771-15.391Zm.056-2.747H8.8c-.056,0-.111.056-.139.166A2.093,2.093,0,0,0,8.743-16.7a.217.217,0,0,0,.028-.084c.277-.86.222-1.248.138-1.332A.118.118,0,0,0,8.826-18.138Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M.694-2.429V-7.536H18.318v2.255h.694V-19.86l-5.968-5.994H0V-1.735H16l-.537-.694ZM13.211-24.689l4.608,4.635H13.211ZM.694-25.16H12.545v5.773h5.773v11.38H.694Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M17.313-1.735,18.656,0,20-1.736H17.313Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M18.3-2.429h.016V-4.24H18.3Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M18.3-2.429v.693h.708v-2.5h-.692v1.811Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M7.017-6.371H5.828v2.642h.357V-4.844h.832A.736.736,0,0,0,7.8-5.628.722.722,0,0,0,7.017-6.371ZM6.9-5.149h-.71v-.917H6.91c.294,0,.523.107.523.442C7.433-5.267,7.216-5.149,6.9-5.149Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M9.337-6.371H8.266v2.642H9.322c.869,0,1.126-.766,1.126-1.358A1.133,1.133,0,0,0,9.337-6.371ZM9.314-4.034H8.623V-6.066h.666c.486,0,.791.336.791,1S9.778-4.034,9.314-4.034Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M11.3-3.729h-.357V-6.371h1.829v.317H11.3v.81h1.3v.316H11.3Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.84a40968e5625ea64a8172c8a92abc91.svg";
export { ForwardRef as ReactComponent };